import { useState, useEffect } from "react";

import { useNavigate, useParams } from "react-router-dom";

import { Skull, Smile } from "lucide-react";

import api from "../../api/axios";

const SetPassword = () => {
    const navigate = useNavigate();
    const { token: routeToken } = useParams();

    const [token, setToken] = useState("");

    const [password, setPassword] =
        useState("");

    const [confirmPassword, setConfirmPassword] =
        useState("");

    const [showPassword, setShowPassword] =
        useState(false);

    const [
        showConfirmPassword,
        setShowConfirmPassword,
    ] = useState(false);

    const [error, setError] = useState("");

    const [success, setSuccess] =
        useState("");

    const [loading, setLoading] =
        useState(false);

    // STRONG PASSWORD REGEX
    const strongPassword =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).{8,}$/;

    useEffect(() => {
        const params =
            new URLSearchParams(
                window.location.search,
            );

        const hashParams =
            new URLSearchParams(
                window.location.hash.replace(/^#/, ""),
            );

        const pathToken =
            window.location.pathname
                .split("/")
                .filter(Boolean)[1];

        const t = (
            params.get("token") ||
            params.get("setupToken") ||
            hashParams.get("token") ||
            routeToken ||
            pathToken ||
            ""
        ).trim();

        if (!t) {
            setError(
                "Invalid invite link",
            );
        } else {
            setToken(t);
        }
    }, [routeToken]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        setError("");

        if (
            password !==
            confirmPassword
        ) {
            return setError(
                "Passwords do not match",
            );
        }

        if (
            !strongPassword.test(
                password,
            )
        ) {
            return setError(
                "Password must contain uppercase, lowercase, number, special character and minimum 8 characters",
            );
        }

        try {
            setLoading(true);

            const res = await api.post(
                "/api/employee/auth/set-password",
                {
                    token: token.trim(),
                    password,
                    confirmPassword,
                },
            );

            setSuccess(
                res.data.message,
            );
        } catch (err) {
            console.error("SET PASSWORD ERROR:", err);
            if (err.response) {
                const status = err.response.status;
                const msg = err.response.data?.message || err.response.statusText;
                setError(`Server Error (${status}): ${msg}`);
            } else {
                setError(`Network/Request Error: ${err.message || String(err)}`);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#111] flex items-center justify-center px-4">

            <div className="w-full max-w-md bg-[#1e1e1e] border border-[#2a2a2a] rounded-2xl p-8 shadow-2xl">

                {/* LOGO */}
                <div className="flex justify-center mb-6">
                    <img src="/logo.png" alt="Savrion Technologies Logo" className="w-48 h-auto object-contain" />
                </div>

                {/* TITLE */}
                <div className="text-center mb-8">

                    <h1 className="text-3xl font-bold text-white mb-2">
                        Set Your Password
                    </h1>

                    <p className="text-gray-400 text-sm">
                        Welcome to Savrion Technologies Team Portal
                    </p>

                </div>

                {/* ERROR */}
                {error && (
                    <div className="mb-5 bg-red-500/10 border border-red-500/20 text-red-400 text-sm rounded-xl px-4 py-3">
                        {error}
                    </div>
                )}

                {/* SUCCESS */}
                {success && (
                    <div className="mb-5 bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-sm rounded-xl px-4 py-3">
                        {success}
                    </div>
                )}

                {!success ? (
                    <form
                        onSubmit={
                            handleSubmit
                        }
                        className="space-y-5"
                    >

                        {/* PASSWORD */}
                        <div>

                            <label className="block text-sm text-gray-400 mb-2">
                                Password
                            </label>

                            <div className="relative">

                                <input
                                    type={
                                        showPassword
                                            ? "text"
                                            : "password"
                                    }
                                    placeholder="Enter password"
                                    value={
                                        password
                                    }
                                    onChange={(
                                        e,
                                    ) =>
                                        setPassword(
                                            e.target
                                                .value,
                                        )
                                    }
                                    required
                                    className="w-full bg-[#111] border border-[#2a2a2a] focus:border-emerald-500 rounded-xl px-4 py-3 pr-14 text-white outline-none transition"
                                />

                                <button
                                    type="button"
                                    onClick={() =>
                                        setShowPassword(
                                            !showPassword,
                                        )
                                    }
                                    className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 hover:text-emerald-400 transition"
                                >
                                    {showPassword ? (
                                        <Smile
                                            size={
                                                20
                                            }
                                        />
                                    ) : (
                                        <Skull
                                            size={
                                                20
                                            }
                                        />
                                    )}
                                </button>

                            </div>

                        </div>

                        {/* CONFIRM PASSWORD */}
                        <div>

                            <label className="block text-sm text-gray-400 mb-2">
                                Confirm Password
                            </label>

                            <div className="relative">

                                <input
                                    type={
                                        showConfirmPassword
                                            ? "text"
                                            : "password"
                                    }
                                    placeholder="Confirm password"
                                    value={
                                        confirmPassword
                                    }
                                    onChange={(
                                        e,
                                    ) =>
                                        setConfirmPassword(
                                            e.target
                                                .value,
                                        )
                                    }
                                    required
                                    className="w-full bg-[#111] border border-[#2a2a2a] focus:border-emerald-500 rounded-xl px-4 py-3 pr-14 text-white outline-none transition"
                                />

                                <button
                                    type="button"
                                    onClick={() =>
                                        setShowConfirmPassword(
                                            !showConfirmPassword,
                                        )
                                    }
                                    className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 hover:text-emerald-400 transition"
                                >
                                    {showConfirmPassword ? (
                                        <Smile
                                            size={
                                                20
                                            }
                                        />
                                    ) : (
                                        <Skull
                                            size={
                                                20
                                            }
                                        />
                                    )}
                                </button>

                            </div>

                        </div>

                        {/* RULES */}
                        <div className="bg-[#111] border border-[#2a2a2a] rounded-xl p-4">

                            <p className="text-sm text-gray-300 mb-2 font-medium">
                                Password Policy & Requirements
                            </p>

                            <ul className="text-xs text-gray-500 space-y-1 list-disc pl-5">

                                <li className="text-emerald-400 font-semibold">
                                    Use a strong, unique password
                                </li>

                                <li>
                                    Minimum 8 characters
                                </li>

                                <li>
                                    At least one uppercase letter
                                </li>

                                <li>
                                    At least one lowercase letter
                                </li>

                                <li>
                                    At least one number
                                </li>

                                <li>
                                    At least one special character
                                </li>

                            </ul>

                        </div>

                        {/* BUTTON */}
                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full bg-emerald-500 hover:bg-emerald-600 disabled:opacity-60 disabled:cursor-not-allowed text-black font-semibold py-3 rounded-xl transition"
                        >
                            {loading
                                ? "Submitting..."
                                : "Set Password"}
                        </button>

                    </form>
                ) : (
                    <button
                        onClick={() =>
                            navigate("/login")
                        }
                        className="w-full bg-emerald-500 hover:bg-emerald-600 text-black font-semibold py-3 rounded-xl transition"
                    >
                        Go to Login
                    </button>
                )}

            </div>
        </div>
    );
};

export default SetPassword;
